module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/OYXBv6/tc-custom/9781683351542.jpg?1705981893140",
      "alt": "This image is the cover for the book Sisters Grimm: Magic and Other Misdemeanors, The Sisters Grimm"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sisters Grimm: Magic and Other Misdemeanors, The Sisters Grimm\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The sister detectives set out to catch a magical thief in the fifth adventure in the "), _c('i', [_vm._v("New York Times–")]), _vm._v("bestselling children’s fantasy series.")]), _c('br'), _c('br'), _vm._v(" In this latest adventure, intrepid fairy-tale detectives Sabrina and Daphne Grimm investigate a sudden streak of magical thefts that might add up to a very grim future for their family. With Granny Relda desperately scrambling to pay Mayor Heart’s outrageous taxes on humans, the Sisters Grimm tackle their first solo case—with a little help from Puck, of course."), _c('br'), _c('br'), _vm._v(" Meanwhile, their old friend Mr. Canis seems to be losing his grip on his human self, becoming more like the Big Bad Wolf every day. Can Sabrina and Daphne solve the crime and change their family’s future for the better?"), _c('br'), _c('br'), _vm._v(" Reissued with new cover art, these anniversary editions of the beloved Sisters Grimm series are the perfect opportunity for old fans to revisit the Grimm family’s adventures and for new readers to discover the magic of the series.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael Buckley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Michael Buckley is the author of the successful Sisters Grimm and NERDS series. He is also the author of the Undertow trilogy. He lives in New York City. Peter Ferguson is an illustrator of picture books, comic books, and novels. He lives in Montreal, Canada.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    ABRAMS\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0